import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "exception-limit-settings__title-block" }
const _hoisted_2 = { class: "exception-limit-settings__logo" }
const _hoisted_3 = {
  key: 0,
  class: "exception-limit-settings__name-block"
}
const _hoisted_4 = { class: "exception-limit-settings__limit-list-item-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FallbackImage = _resolveComponent("FallbackImage")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_LimitException = _resolveComponent("LimitException")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: _ctx.isExceptionLimitSettingsSidebarVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isExceptionLimitSettingsSidebarVisible) = $event)),
    title: _ctx.exceptionLimitHeader,
    "append-to-body": "",
    size: "700",
    class: "exception-limit-settings",
    onClose: _ctx.closeExceptionLimitSettings
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_FallbackImage, {
              "model-value": _ctx.currentPaymentMethod,
              class: "exception-limit-settings__image"
            }, null, 8 /* PROPS */, ["model-value"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infoFieldList, ({ label, value }) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: label }, [
              value
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                    _createElementVNode("span", null, _toDisplayString(label), 1 /* TEXT */),
                    _createVNode(_component_el_tag, {
                      type: _ctx.TagComponentTypes.INFO
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(value), 1 /* TEXT */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["type"])
                  ]))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.extendedPaymentMethodExceptionLimitList, (exceptionLimit) => {
          return (_openBlock(), _createBlock(_component_el_card, {
            key: exceptionLimit.currency,
            shadow: "hover",
            class: "exception-limit-settings__card-item"
          }, {
            header: _withCtx(() => [
              _createTextVNode(_toDisplayString(exceptionLimit.currency ?? 'Currency not selected') + " ", 1 /* TEXT */),
              _createVNode(_component_el_tag, {
                type: _ctx.TagComponentTypes.INFO,
                class: "exception-limit-settings__card-tag"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(exceptionLimit.min) + " - " + _toDisplayString(exceptionLimit.max), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["type"])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(exceptionLimit.limitList, (exceptionLimitItem) => {
                    return (_openBlock(), _createBlock(_component_LimitException, {
                      key: exceptionLimitItem.id,
                      "exception-limit-item": exceptionLimitItem,
                      class: "exception-limit-settings__limit-list-item",
                      onUpdateExceptionLimitItem: _ctx.updateExceptionLimitItem
                    }, null, 8 /* PROPS */, ["exception-limit-item", "onUpdateExceptionLimitItem"]))
                  }), 128 /* KEYED_FRAGMENT */)),
                  (_ctx.isAddLimitExceptionButtonVisible)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        disabled: !_ctx.isAddExceptionLimitItemEnable(exceptionLimit.currency),
                        class: "exception-limit-settings__add-exception",
                        type: "primary",
                        link: "",
                        onClick: ($event: any) => (_ctx.addExceptionLimitItem(exceptionLimit.currency))
                      }, {
                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                          _createTextVNode(" Add exceptions ", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["disabled", "onClick"]))
                    : _createCommentVNode("v-if", true)
                ])
              ])
            ]),
            _: 2 /* DYNAMIC */
          }, 1024 /* DYNAMIC_SLOTS */))
        }), 128 /* KEYED_FRAGMENT */))
      ])), [
        [_directive_loading, _ctx.isExceptionLimitListLoading]
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue", "title", "onClose"]))
}